module.exports = __webpack_public_path__ + "static/media/logout.d3c8eff9.svg";